class Projects {
  constructor() {
    const projects = document.getElementsByClassName(
      "post-type-archive-projects"
    )[0];
    if (projects) {
      this.init();
    }
  }

  /* eslint-disable class-methods-use-this, no-unused-vars */
  init() {
    const gridFilters = document
      .getElementsByClassName("grid__filters__list")[0]
      .querySelectorAll("li");

    // If the url contains a filter apply it
    if (gridFilters) {
      const tabHash = window.location.hash;
      Array.prototype.forEach.call(gridFilters, (filter) => {
        if (tabHash && filter) {
          const tabId = tabHash.replace("#", "");
          const filterAnchor = filter.querySelector("a");
          const currentTerm = filterAnchor.dataset.term;

          // Select the filter
          if (currentTerm === tabId) {
            filterAnchor.click();
          }
        }
      });
    }
  }
  /* eslint-enable class-methods-use-this, no-unused-vars */
}

export default Projects;
